import { IsArray, IsString } from 'class-validator';

export class GoldenRecordSubTypePatternDto {
  @IsString()
  dbValue: string;
  @IsString()
  value: string;
  @IsString()
  label: string;
  @IsArray()
  pattern: Array<string>;
}
